<div class="modal-backdrop fade" [class.show]="isOpen" *ngIf="isOpen"></div>

<div class="modal fade" [class.show]="isOpen" [style.display]="isOpen ? 'block' : 'none'"
    [class.investment-variant]="variant === 'investment'" tabindex="-1" role="dialog"
    (click)="closeModal(); $event.stopPropagation()">
    <div class="modal-dialog modal-dialog-centered" role="document" (click)="$event.stopPropagation()">
        <div class="modal-content custom-modal-content">
            <!-- Modal Header -->
            <div class="modal-header custom-modal-header border-0"
                [ngClass]="{'justify-content-between align-items-center': variant === 'investment'}">
                <ng-container *ngIf="variant === 'default'">
                    <button type="button" class="btn-cancel" (click)="onCancel()" *ngIf="showCancel">
                        {{ cancelLabel }}
                    </button>
                    <h5 class="modal-title">{{ title }}</h5>
                    <button type="button" class="btn-done" (click)="onDone()" *ngIf="showDone">
                        {{ doneLabel }}
                    </button>
                </ng-container>

                <ng-container *ngIf="variant === 'investment'">
                    <div class="d-flex align-items-center gap-3">
                        <button type="button" class="btn-cancel" (click)="onCancel()" *ngIf="showCancel">
                            {{ cancelLabel }}
                        </button>
                        <h5 class="modal-title">{{ title }}</h5>
                    </div>
                    <button type="button" class="btn-done investment-btn-done" (click)="onDone()" *ngIf="showDone">
                        {{ doneLabel }}
                    </button>
                </ng-container>
            </div>

            <!-- Modal Body -->
            <div class="modal-body custom-modal-body">
                <p class="subtitle text-center" *ngIf="subtitle">{{ subtitle }}</p>

                <!-- Content Slot -->
                <ng-content></ng-content>
            </div>
        </div>
    </div>
</div>